export default "__VITE_ASSET__B5bKqoJd__"